var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavegray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1218 1.99609C10.4731 2.0011 10.8082 2.14471 11.0541 2.39565L13.5847 4.92616C13.8356 5.17206 13.9792 5.50716 13.9842 5.85846V12.6509C13.9842 13.0041 13.8439 13.3429 13.5941 13.5927C13.3443 13.8424 13.0056 13.9827 12.6524 13.9827H3.32941C2.97618 13.9827 2.63742 13.8424 2.38765 13.5927C2.13788 13.3429 1.99756 13.0041 1.99756 12.6509V3.32794C1.99756 2.97472 2.13788 2.63595 2.38765 2.38618C2.63742 2.13641 2.97618 1.99609 3.32941 1.99609H10.1218Z",
    stroke: "#364153",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3209 13.9837V9.32218C11.3209 9.14556 11.2507 8.97618 11.1258 8.8513C11.0009 8.72641 10.8316 8.65625 10.6549 8.65625H5.32755C5.15093 8.65625 4.98155 8.72641 4.85667 8.8513C4.73178 8.97618 4.66162 9.14556 4.66162 9.32218V13.9837",
    stroke: "#364153",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66162 1.99609V4.65979C4.66162 4.83641 4.73178 5.00579 4.85667 5.13067C4.98155 5.25556 5.15093 5.32572 5.32755 5.32572H9.98902",
    stroke: "#364153",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavegray);
export default __webpack_public_path__ + "static/media/savegray.f672cc889e2f733b5c43d8d52f1de889.svg";
export { ForwardRef as ReactComponent };